import React from 'react'
import { format } from 'date-fns'
import { useUserTimezone } from '../../hooks/useUserTimezone'
import { ClockCheckIcon } from '../SelfScheduleModal/icons'
import './BookedConfirmation.scss'

interface BookedConfirmationProps {
  date: Date
  time: string
}

// Format a slot time like "3:00 PM" into "3pm" (or "3:30pm" when not on the hour)
const formatBookedTime = (time: string): string => {
  const [clock, meridiem] = time.split(' ')
  const [hour, minute] = clock.split(':')
  const suffix = (meridiem ?? '').toLowerCase()
  return minute === '00' ? `${hour}${suffix}` : `${hour}:${minute}${suffix}`
}

function BookedConfirmation ({ date, time }: BookedConfirmationProps) {
  const { abbreviation: timezone } = useUserTimezone()

  return (
    <div className="booked-confirmation">
      <ClockCheckIcon />
      <p className="booked-confirmation__text">
        You&#39;ve booked {formatBookedTime(time)} {timezone} on {format(date, 'M/d')}
      </p>
    </div>
  )
}

export default BookedConfirmation
